import {TableSettings} from "../../../tableSettings";

export const otherShipmentList:TableSettings = {
  tableVersion: 10077,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  flexResizer: false,

  alternateRows: true,
  columns: [ ]
};

export const otherShipmentContainerDetails:TableSettings = {
  tableVersion: 1014,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '120px',
  flexResizer: true,

  columns: [
    { Header: 'Container #',  accessor: 'containerNo', resizable: false, sortable: false, visible: true, initialWidthPercentage: 22.15 },
    { Header: 'Type',         accessor: 'conType',     resizable: false, sortable: false, visible: true, initialWidthPercentage: 14.34 },
    { Header: 'Seal #',       accessor: 'sealNo',      resizable: false, sortable: false, visible: true, initialWidthPercentage: 17.99 },
    { Header: 'Packages',     accessor: 'pkgs',        resizable: false, sortable: false, visible: true, initialWidthPercentage: 14.34 },
    { Header: 'Weight (KGS)', accessor: 'kgs',         resizable: false, sortable: false, visible: true, initialWidthPercentage: 14.34 },
    { Header: 'Weight (LBS)', accessor: 'lbs',         resizable: false, sortable: false, visible: true, initialWidthPercentage: 14.34 },
    { Header: '',             accessor: 'scroll',      resizable: false, sortable: false, visible: true, initialWidthPercentage: 2.5 },
  ]
};

export const otherShipmentInvenDetails:TableSettings = {
  tableVersion: 1007,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '106px',
  flexResizer: true,

  columns: [
    {
      Header: 'Length',
      accessor: 'length',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 18.88,
    },
    {
      Header: 'Width',
      accessor: 'width',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 18.88,
    },
    {
      Header: 'Height',
      accessor: 'height',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 18.88,
    },
    {
      Header: 'Pkgs',
      accessor: 'pcs',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 16.88,
    },
    {
      Header: 'CBM',
      accessor: 'chgWeight',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 20.88,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 5.55,
    },
  ]
};

export const otherShipmentQuotationList:TableSettings={
  tableVersion: 10009,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  flexResizer: false,

  alternateRows: true,
  columns: [ ]
};

export const containerStatusList:TableSettings = {
  tableVersion: 10078,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  flexResizer: false,

  alternateRows: true,
  columns: []
};
